import React from 'react';

import { SVGComponentProps } from './svg.types';

const ViewSVG = ({ fill = 'currentColor', size = '1em', ...otherProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M13.7081 5.4136e-05H8.75C8.57502 5.4136e-05 8.45831 0.145836 8.45831 0.291737V1.75009C8.45831 1.89588 8.575 2.04178 8.75 2.04178H11.9582V5.25001C11.9582 5.39579 12.0749 5.5417 12.2499 5.5417H13.7083C13.8833 5.5417 14 5.39591 14 5.25001L13.9998 0.291682C13.9998 0.145795 13.8832 0 13.7082 0L13.7081 5.4136e-05Z"
        fill={fill}
      />
      <path
        d="M3.05176e-05 13.7079C3.05176e-05 13.8536 0.11672 13.9995 0.291713 13.9995H5.25004C5.42502 13.9995 5.54173 13.8538 5.54173 13.7079V12.2495C5.54173 12.1037 5.42504 11.9578 5.25004 11.9578L2.04181 11.9579V8.74969C2.04181 8.60391 1.92512 8.45801 1.75013 8.45801H0.291875C0.116896 8.45801 0.000192925 8.60379 0.000192925 8.74969L3.05176e-05 13.7079Z"
        fill={fill}
      />
      <path
        d="M0.291846 5.54153H1.7502C1.92518 5.54153 2.04189 5.39575 2.04189 5.24985L2.04178 2.04161H5.25002C5.425 2.04161 5.5417 1.89583 5.5417 1.74993V0.291682C5.5417 0.145901 5.42501 0 5.25002 0H0.291957C0.116978 0 0.000274658 0.145782 0.000274658 0.291682V5.25001C0.000274658 5.39579 0.116964 5.54159 0.291957 5.54159L0.291846 5.54153Z"
        fill={fill}
      />
      <path
        d="M13.708 8.45806H12.2496C12.0747 8.45806 11.958 8.60384 11.958 8.74974V11.958H8.74972C8.57474 11.958 8.45804 12.1038 8.45804 12.2497V13.708C8.45804 13.8538 8.57473 13.9997 8.74972 13.9997H13.7081C13.883 13.9997 13.9997 13.8539 13.9997 13.708L13.9996 8.74969C13.9996 8.6038 13.8829 8.45801 13.7079 8.45801L13.708 8.45806Z"
        fill={fill}
      />
    </svg>
  );
};

export default ViewSVG;
